import { GenerateDisputeNotesDTO } from "@/core/dto/deduction/disputeDeduction";
import { IDeductionDisputeRepository } from "@/core/repositories/deduction";

export class GenerateDisputeNotesUseCase {
  constructor(private readonly disputeRepository: IDeductionDisputeRepository) {}

  async execute(params: GenerateDisputeNotesDTO): Promise<string> {
    return this.disputeRepository.generateDisputeNotes(params);
  }
}
